var map = {
	"./icon-default.svg": 52722,
	"./icon-facebook.svg": 40595,
	"./icon-instagram.svg": 817,
	"./icon-ofidi.svg": 10188,
	"./icon-presencial.svg": 20303,
	"./icon-telefono.svg": 7739,
	"./icon-whatsapp.svg": 13565,
	"./tilde-selected.svg": 43281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10329;